import * as c from '@chakra-ui/react'
import { Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react'

import { ArrowLeftIcon } from '../icons/arrow-left.icon'
import { ArrowRightIcon } from '../icons/arrow-right.icon'
import { MapIcon } from '../icons/map.icon'
import { PinIcon } from '../icons/pin.icon'
import { ListItem } from '.'

interface FilterProps {
  data: ListItem[]
  index: number
}

export default function Filter({ data, index }: FilterProps) {
  const [isMobile] = c.useMediaQuery('(max-width: 720px)')

  return (
    <c.TabList w="full" maxW="672px">
      <Swiper
        slidesPerView={isMobile ? 3 : 6}
        slidesPerGroupAuto
        navigation={{
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        }}
        modules={[Navigation]}
      >
        {data?.map((item, i) => {
          const isActive = index === i
          return (
            <SwiperSlide key={i}>
              <c.Tab
                minW="full"
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap="s2"
              >
                <c.Icon
                  as={isActive ? PinIcon : MapIcon}
                  color={isActive ? 'primary.500' : 'black.400'}
                  h="24px"
                  w="24px"
                />
                <c.Text
                  color={isActive ? 'primary.500' : 'black.400'}
                  fontWeight={isActive ? 'bold' : 'medium'}
                >
                  {item.name}
                </c.Text>
              </c.Tab>
            </SwiperSlide>
          )
        })}

        <NavigationButtons />
      </Swiper>
    </c.TabList>
  )
}

function NavigationButtons() {
  return (
    <c.Flex
      position="absolute"
      top={0}
      bottom={6}
      left={0}
      right={0}
      justify="space-between"
    >
      <c.Button
        className="swiper-button-prev"
        size="xs"
        variant="light"
        h="24px"
        bg={['black.0', 'black.100']}
        _focus={{
          border: 'none',
        }}
      >
        <c.Icon as={ArrowLeftIcon} color="black.500" h="" w="" />
      </c.Button>

      <c.Button
        className="swiper-button-next"
        size="xs"
        variant="light"
        h="24px"
        bg={['black.0', 'black.100']}
        _focus={{
          border: 'none',
        }}
      >
        <c.Icon as={ArrowRightIcon} color="black.500" h="" w="" />
      </c.Button>
    </c.Flex>
  )
}
